import type { App } from "vue";
import LanguageSwitcher from "core-fe-lib/components-shadcn/primitives/LanguageSwitcher.vue";
import BPage from "core-fe-lib/components-shadcn/primitives/BPage.vue";
import BDiv from "core-fe-lib/components-shadcn/primitives/BDiv.vue";
import BTitle from "core-fe-lib/components-shadcn/primitives/BTitle.vue";
import Icon from "core-fe-lib/components-shadcn/Icon.vue";

/**
 * Register global components from core-fe-lib
 * These components are available throughout the application without explicit imports
 */
export function registerGlobalComponents(app: App) {
  app.component("BPage", BPage);
  app.component("LanguageSwitcher", LanguageSwitcher);
  app.component("BDiv", BDiv);
  app.component("BTitle", BTitle);
  app.component("Icon", Icon);
}
